(ns admin.events.core
  (:require [re-frame-notifier.core :as rf-notifier]
            [re-frame-request.core :as rf-request]
            [re-frame-routing.core :as rf-routing]

            [kyber.events.analytics :refer [initialize-analytics]]
            [kyber.events.authentication :as kyber-auth]
            [kyber.events.bootstrap :refer [initialize-kyber-bootstrap]]
            [kyber.events.i18n]
            [kyber.events.pdf-viewer]
            [kyber.events.location]
            [kyber.events.media-player]
            [kyber.events.ui]
            [kyber.events.utils :refer [check-spec-interceptor*
                                        kyber-event-db]]
            [kyber.interceptors.analytics :refer [update-application-context]]
            [common.transit :as transit]
            [admin.db.core :refer [db-reset]]

            [admin.events.activities]
            [admin.events.activity-report]
            [admin.events.activity-resources]
            [admin.events.activity-questions]
            [admin.events.boosts]
            [admin.events.bootstrap]
            [admin.events.content-provider]
            [admin.events.identity-providers]
            [admin.events.curricula]
            [admin.events.tag]
            [admin.events.insights]
            [admin.events.learner-reporting]
            [admin.events.learning-objectives]
            [admin.events.moments]
            [admin.events.questionnaires]
            [admin.events.reports]
            [admin.events.resources]
            [admin.events.resource-library]
            [admin.events.users]
            [admin.router.routes :as routes]))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Third Party Re-Frame Events
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf-notifier/register-events
 {:notifier-interceptors [check-spec-interceptor*]})

(rf-request/register-events
 {:request-interceptors [check-spec-interceptor*]
  :transit-read-handlers transit/read-handlers
  :transit-write-handlers transit/write-handlers})

(rf-routing/register-events
 {:set-route-interceptors (conj [check-spec-interceptor*]
                                update-application-context)
  :routes routes/routes})

(kyber-auth/initialize-aws-services)
(initialize-kyber-bootstrap)
(initialize-analytics {:debug false})
(kyber-auth/initialize-authentication)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; MISC
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kyber-event-db :db/reset db-reset)
